module.exports = "https://cdn.dove.it/_next/static/public/assets/lead-invitation-background.59fb1c3c15870b179a171eba24940faa.jpg";